import { createFileRoute } from "@tanstack/react-router"
import { SiteFooter } from "../components/SiteFooter"
import { SiteHeader } from "../components/SiteHeader"
import { WeekSchedule } from "../components/WeekSchedule"
import { scheduleGet } from "../utils/schedule"

export const Route = createFileRoute("/")({
  loader: async () => scheduleGet(),
  component: IndexComponent,
})

function IndexComponent() {
  const { weekKeys, weeksRecord, currentWeekKey } = Route.useLoaderData()
  const weeks = new Map(Object.entries(weeksRecord))

  return (
    <>
      <SiteHeader />
      <main className="flex flex-col items-center pb-brew-section-tablet">
        <WeekSchedule
          weekKeys={weekKeys}
          weeks={weeks}
          initialWeekKey={currentWeekKey}
        />
      </main>
      <SiteFooter />
    </>
  )
}
